import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {CommonService} from '../../common/controller/common.service';
import {ApiMessageService} from '../../core/api-message.service';
import {Router} from '@angular/router';
import {JsonBaseBuilder} from '../../common/builder/json-base-builder';
import {RuoloUtente} from './ruoloutente.model';
import {ConfigService} from '../../core/config.service';
import {Table} from '../../common/model/table.model';
import {MODULE_CONFIGURAZIONE} from '../../app-routing.module';

@Injectable()
export class RuoloUtenteService extends CommonService<RuoloUtente> {

  public static ROUTE = 'ruoloutente';

  public constructor(protected httpClient: HttpClient,
                     protected apiMessageService: ApiMessageService,
                     protected router: Router,
                     protected configService: ConfigService) {
    super(httpClient, apiMessageService, router, configService);
  }

  public buildInstance(json: any): RuoloUtente {
    return JsonBaseBuilder.jsonToRuoloUtente(json);
  }

  public getModule(): string {
    return MODULE_CONFIGURAZIONE;
  }

  public getApiService(): string {
    return ConfigService.ACE;
  }

  public getTable(items: RuoloUtente[]): Table {
    return Table.buildBaseTable(RuoloUtente.getTableKeys(), items);
  }

  public getRoute(): string {
    return RuoloUtenteService.ROUTE;
  }

}
